export default {
  STRING: 0,
  NUMBER: 1,
  DATE: 2,
};